import React from 'react';
import SentimentSatisfiedAltIcon from '@material-ui/icons/SentimentSatisfiedAlt';

const IconePossuiBiometriaFacial = () => {
    return (
        <div style={{backgroundColor: 'transparent', width: 36, height: 39}}>
            <div style={{float: 'left', backgroundColor: '#05B59D', width:11, height: 3}}></div>
            <div style={{float: 'left', backgroundColor: 'transparent', width:14, height: 3}}></div>
            <div style={{float: 'left', backgroundColor: '#05B59D', width:11, height: 3}}></div>
            <div style={{float: 'left', backgroundColor: '#05B59D', width:3, height: 10}}></div>
            <div style={{float: 'right', backgroundColor: '#05B59D', width:3, height: 10}}></div>
            <div style={{clear: 'both'}}></div>
            <div style={{float: 'left', backgroundColor: 'transparent', width:3, height: 13}}></div>
            <div style={{textAlign: 'center', marginLeft: 'auto', marginTop: -5, marginBottom: -20, marginRight: 'auto'}}><SentimentSatisfiedAltIcon style={{ color: '#222224'}} /> </div>
            <div style={{float: 'right', backgroundColor: 'transparent', width:3, height: 13}}></div>
            <div style={{clear: 'both'}}></div>
            <div style={{float: 'left', backgroundColor: '#05B59D', width:3, height: 10}}></div>
            <div style={{float: 'right', backgroundColor: '#05B59D', width:3, height: 10}}></div>     
            <div style={{clear: 'both'}}></div>  
            <div style={{float: 'left', backgroundColor: '#05B59D', width:11, height: 3}}></div>
            <div style={{float: 'left', backgroundColor: 'transparent', width:14, height: 3}}></div>
            <div style={{float: 'left', marginBottom: -3, backgroundColor: '#05B59D', width:11, height: 3}}></div>              
      </div>
    );
  }
;

export default IconePossuiBiometriaFacial;